/**
 * Created by jv on 10/03/2017.
 */

if(!__DEVELOPMENT__)
{
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'UA-61834383-2');
}
else
{
  console.log("development Google Analytics disabled");
}



// WEBPACK FOOTER //
// ./app/js/misc/google-analytics.js